module.exports = __webpack_public_path__ + "img/player_bg2.307dc89b.png";